import { IconButton, InputAdornment, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import { useSelector } from 'react-redux';
import Iconify from '../../../../reusable-components/iconify';
import { formStyle } from '../TransitionStyles';

FormMoneyField.propTypes = {
  fieldName: PropTypes.string,
  fieldAttributes: PropTypes.object,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
};

export default function FormMoneyField({ fieldName, fieldAttributes, focusedField, setFocusedField }) {
  const { setValue, control } = useFormContext();
  const isCanceled = useSelector((state) => state.transitions?.data?.isCanceled);

  return (
    <Controller
      name={fieldName}
      control={control}
      rules={{
        pattern: {
          value: /^\d+(\.\d{1,2})?$/,
          message: 'Enter a valid amount (e.g., 100.00)',
        },
      }}
      render={({ field, fieldState }) => (
        <NumericFormat
          inputRef={field.ref}
          key={field.id}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
          }}
          customInput={TextField}
          onFocus={() => setFocusedField(fieldName)}
          fullWidth
          disabled={!fieldAttributes.isEditable || isCanceled}
          size="small"
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          value={!field.value === '' || Number.isNaN(field.value) ? '' : field.value}
          onValueChange={(values) => field.onChange(values.floatValue ?? '')}
          allowNegative={false}
          thousandSeparator
          decimalScale={2}
          fixedDecimalScale
          sx={{
            ...formStyle,
            '& .MuiInputAdornment-root': {
              marginRight: 0,
            },
          }}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
            endAdornment:
              field.value && focusedField === fieldName ? (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.preventDefault();
                      setValue(fieldName, '');
                    }}
                    edge="end"
                    tabIndex={-1}
                  >
                    <Iconify icon="eva:close-outline" />
                  </IconButton>
                </InputAdornment>
              ) : null,
            sx: {
              '& .MuiInputAdornment-root': {
                color: '#000000',
              },
            },
          }}
        />
      )}
    />
  );
}
